import gql from 'graphql-tag';
import { PROJECT_BANK_ATTACHMENT_SELECTION } from './projectBankAttachmentSelection';

/**
 * Data of the block project-bank-rental-income ("Mieteinnahmen", tab Bank): its fields of `bank` and the bank attachments of its types. Read through
 * `Project.blocks.bankRentalIncome`, which checks the block's read permission.
 */
export const PROJECT_BANK_RENTAL_INCOME_FIELDS = gql`
  fragment projectBankRentalIncomeFields on ProjectBankRentalIncomeBlock {
    id
    number
    bank {
      hasRentalIncome
      ${PROJECT_BANK_ATTACHMENT_SELECTION}
    }
  }
`;
